import { render, staticRenderFns } from "./HistoryComplaintDetail.vue?vue&type=template&id=3bd89af0&"
import script from "./HistoryComplaintDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryComplaintDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports